export default __webpack_public_path__ + "images/models/3db13fe3cfb7eb7ffae0e7677d92cdc2.glb";